export const isGrantedProfile = (profile) => Boolean(profile?.hasAccess);

export const getGrantedProfiles = (profiles = []) => profiles.filter(isGrantedProfile);

export const getLockedProfileCount = (profiles = []) =>
  profiles.filter((profile) => !isGrantedProfile(profile)).length;

export const getAccessibleDashboardProfiles = (entries = []) =>
  entries.filter((entry) => {
    if (Boolean(entry?.hasAccess) || Boolean(entry?.summary?.hasAccess)) {
      return true;
    }

    return Boolean(entry?.activeAttempt)
      || Boolean(entry?.latestCompletedAttempt)
      || (entry?.summary?.attemptCount || 0) > 0;
  });
